import { useMemo } from 'react';

import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacet } from '#/modules/search/types/SearchFacet';

import { localeFacet } from './searchFacets/localeFacet';
import { locationTypeFacet } from './searchFacets/locationTypeFacet';
import { orgAreasOfFocusFacet } from './searchFacets/orgAreasOfFocusFacet';
import { orgTypeFacet } from './searchFacets/orgTypeFacet';
/**
 * Only use this function if the code consuming the output does not rely on a stable object.
 *
 * If it does, use the hook instead
 */
export function unstableOrgSearchFacets(i18n: I18nFn) {
  return [
    locationTypeFacet(i18n),
    orgAreasOfFocusFacet(i18n),
    orgTypeFacet(i18n),
    localeFacet(i18n),
  ] as const satisfies SearchFacet[];
}

export function useSearchFacetsOrg(i18n: I18nFn) {
  const orgSearchFacets = useMemo(() => unstableOrgSearchFacets(i18n), [i18n]);

  return { orgSearchFacets };
}
